import { ALL_PATIENTS_PATH } from "@/pages/patients/const";
export const PATIENT_DISPATCH_PAGE = "dispatch";
export const PATIENT_DISPATCH_PATH = `${ALL_PATIENTS_PATH}/${PATIENT_DISPATCH_PAGE}`;
